import { PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-3">
      
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/918369132009" // apna number yaha
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 flex items-center justify-center rounded-full bg-green-500 text-white shadow-lg hover:bg-green-600 transition-all duration-300"
      >
        <WhatsAppOutlined className="text-2xl" />
      </a>

      {/* Call Button */}
      <a
        href="tel:+918369132009" // apna number yaha
        className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-500 text-white shadow-lg hover:bg-blue-600 transition-all duration-300"
      >
        <PhoneOutlined className="text-2xl" />
      </a>

    </div>
  );
};

export default FloatingButtons;
